export const getTime = () => new Date().getTime();

// see https://github.com/behnammodi/polyfill/blob/master/window.polyfill.js
export const onNextFrame = (callback: FrameRequestCallback) => {
  if (typeof window?.requestAnimationFrame === 'function') {
    return window.requestAnimationFrame(callback);
  }

  return setTimeout(() => {
    callback(getTime());
  }, 1000 / 60);
};

export const wait = (time: number): Promise<void> =>
  new Promise((resolve) => setTimeout(() => resolve(), time));
